<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="presuparti"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmpresuparti" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>

<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        <app-invmaebarra (signal)="manejarSenales($event)" [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar"
            [botonBorrar]="btnBorrar" [botonRegresar]="false" [barraBotonesDesplaz]="true" [barraBotones3]="true"
            [barraBotonesAsiCon]="true" [barraBotones5]="true"  [botonBuscarPermanente]="true"
            [botonExcelPermanente]="true" [botonAutorizarPermanente]="true" [botonDescargaPermanente]="true"
            [botonImprimirPermanente]="false"></app-invmaebarra>
    </div>
</div>
<div class="p-grid" style="margin-top: -10px; margin-bottom: -10px; width: 99%;">
	<!--LINEA 1-->
	<div class="p-col-5">
		
	</div>
	<div class="p-col-1">
		<label for="lblestado"></label>
		<input class="frm" id="lblestado" type="text" pInputText
			style="background-color: rgb(40,138,210); font-weight: bold; color: white;" [disabled]="true"
			[(ngModel)]="lblestado" (keydown.enter)="setFocus($event)"
			 autocomplete="off">
	</div>
	
</div>
<div class="p-col-12">
    <p-tabView [(activeIndex)]="index" (activeIndexChange)="cambioTab()">
        <p-tabPanel header="Partidas Presupuestarias">
            <div class="divgrups">
                <div class="p-grid">
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>Año:</span>
                            </div>
                            <div class="p-col-1">
                                <input pInputText type="text" size="4" id="ENCPARPRE_ANIO" 
                                    oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                    (keydown.enter)="busquedaanio(conpartidapresuService.encabezadoPartipresuSelectarray[indicador].ENCPARPRE_ANIO)"
                                    [(ngModel)]="conpartidapresuService.encabezadoPartipresuSelectarray[indicador].ENCPARPRE_ANIO"
                                    (keydown.enter)="setFocus($event)"
                                    autocomplete="off" [maxLength]="4">
                            </div>
                            <div class="p-col-1">
                                <button class="littlebuttons"
                                    style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                    (click)="busquedaanio(conpartidapresuService.encabezadoPartipresuSelectarray[indicador].ENCPARPRE_ANIO)"></button>
                            </div>

                        </div>
                    </div>
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>Descripción:</span>
                            </div>
                            <div class="p-col-11">
                                <input pInputText type="text" size="14" id="ENCPARPRE_COMENTARIO"
                                    [(ngModel)]="conpartidapresuService.encabezadoPartipresuSelectarray[indicador].ENCPARPRE_COMENTARIO"
                                    autocomplete="off" (input)="cambio($event)" [maxLength]="100">
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>Buscar número:</span>
                            </div>
                            <div class="p-col-11">
                                <div class="p-col-1">
                                    <button class="littlebuttons"
                                        style="background-image: url(../../../assets/images/iconos/067-binocular.webp);"
                                        (click)="busquedanumero()"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divg" style="height: 650px">
                <app-aggridsaci [width]="" [height]="200" [enableSorting]="false" [enableFilter]="true"
                    [rowData]="conpartidapresuService.detpartipresupuestoarray" [frameworkComponents]="frameworkComponents"
                    [animateRows]="true" [rowSelection]="rowSelection" [columnDefs]="columnDefspartipresu"
                    [defaultColDef]="defaultColDefPartiPresu" [rowStyle]="rowStyle" [singleClickEdit]="false"
                    [mostrarGuardar]="false" [CC]="true"
                    [botones]="true" (selected)="selectedPartiPresu($event)" (cambios)="cambio($event)">
                </app-aggridsaci>
            </div> 
        </p-tabPanel>
    </p-tabView>
</div>

<input  #inputFile type="file" style="display: none; opacity: 0.0; position: absolute; 
			top: 0; left: 0; bottom: 0; right: 0; width: 25px; height: 25px; cursor: pointer;"
			accept=".xls, .xlsx"
                (change)="onBasicUpload(inputFile.files)" />

                <div style=" 	position: fixed;
				z-index: 999;
				height: 2em;
				width: 2em;
				overflow: visible;
				margin: auto;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;

                ">
<p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
</p-progressSpinner>                

<p-dialog header="Búsqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
    <app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla" [where]="where"
        [busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>

<p-dialog header="Clave Autorización" [(visible)]="displayDialogAutorizacion" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" (onHide)="onHideAutorizacion()" [style]="{width: '40vw', height: 'auto'} ">
	<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="autorizacion"></p-toast>
	<div class="divgrups">
		<div class="p-grid">
			<div class="p-col-12">
				<div class="p-grid">
					<div class="p-col-1"></div>
					<div class="p-col-4">
						<label for="clave" style="font-weight: bold">Clave de Autorización:</label>
					</div>
					<div class="p-col-2"></div>
					<div class="p-col-4">
						<input type="password" pInputText id="clave" [(ngModel)]="claveAuth"
							(keydown.enter)="comprobarClave()" placeholder="Ingrese la clave">
					</div>
					<div class="p-col-1"></div>
				</div>
			</div>
		</div>
	</div>
</p-dialog>

<p-dialog header="Partida Presupuestaria" [(visible)]="displayDialogRazon" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '400px'}">
	<div class="divgrups">

		<div class="ui-g ui-fluid">
			<div class="p-grid">
				<div class="p-col-1">
					<span>Razón</span>
				</div>
				<div class="p-col-11"></div>
				<div class="p-col-12">
					<label for="RAZONAUT"></label>
					<input class="frm" id="RAZONAUT" type="text" pInputText [(ngModel)]="razonaut"
						autocomplete="off" [maxLength]="100">
				</div>
				<div class="p-col-12">
                    <span> {{mensajeestado}} </span>
					
				</div>
				<div class="p-col-8">
				</div>
				<div class="p-col-2">
					<button type="button" class="big"
						style="background-image: url(../../../assets/images/iconos/visto.webp);"
						(click)="autcambiaestado()"></button>
				</div>
				<div class="p-col-2">
					<button type="button" class="big"
						style="background-image: url(../../../assets/images/iconos/borrar.webp);"
						(click)="cancelarautcambiaestado()"></button>
				</div>

			</div>

		</div>
	</div>
</p-dialog>